// src/components/pages/correlation/components/PCAPlot.js

import React from 'react';
import Plot from 'react-plotly.js';
import styles from '../style/CorrPage.module.css'; // 경로 수정 필요

function PCAPlot({ pca, pcaDim, userClusterTraces, userClusterTraces3D, t }) {
  if (pca.explainedVariance.length < pcaDim) return null;

  if (pcaDim === 2) {
    return (
      <div className={styles.chartWrapper}>
        <Plot
          data={userClusterTraces}
          layout={{
            title: t("correlation.pca.title2D", { 
              exp1: (pca.explainedVariance[0] * 100).toFixed(0), 
              exp2: (pca.explainedVariance[1] * 100).toFixed(0) 
            }),
            autosize: true,
            margin: { l: 0, r: 0, t: 10, b: 10 },
            legend: {
              orientation: 'h',    
              x: 0.5,              
              xanchor: 'center',
              y: -0.2              
            },
            xaxis: {
              title: {
                text: t("correlation.pca.axisX", { exp: (pca.explainedVariance[0] * 100).toFixed(0) }),
                font: { size: 10 },
                standoff: 10,
              },
              automargin: true,
            },
            yaxis: {
              title: {
                text: t("correlation.pca.axisY", { exp: (pca.explainedVariance[1] * 100).toFixed(0) }),
                font: { size: 10 },
                standoff: 10,
              },
              automargin: true,
            },
          }}
          style={{ width: "100%", height: "100%" }}
          useResizeHandler={true}
        />
      </div>
    );
  } else if (pcaDim === 3) {
    return (
      <div className={styles.chartWrapper}>
        <Plot
          data={userClusterTraces3D}
          layout={{
            title: t("correlation.pca.title3D", { 
              exp1: (pca.explainedVariance[0] * 100).toFixed(0), 
              exp2: (pca.explainedVariance[1] * 100).toFixed(0), 
              exp3: (pca.explainedVariance[2] * 100).toFixed(0)
            }),
            autosize: true,
            legend: {
              orientation: 'h',
              x: 0.5,
              xanchor: 'center',
              y: -0.2,
            },
            scene: {
              xaxis: { 
                title: { 
                  text: t("correlation.pca.axisX", { exp: (pca.explainedVariance[0] * 100).toFixed(0) }), 
                  font: { size: 10 }
                } 
              },
              yaxis: { 
                title: { 
                  text: t("correlation.pca.axisY", { exp: (pca.explainedVariance[1] * 100).toFixed(0) }),
                  font: { size: 10 }
                } 
              },
              zaxis: { 
                title: { 
                  text: t("correlation.pca.axisZ", { exp: (pca.explainedVariance[2] * 100).toFixed(0) }),
                  font: { size: 10 }
                } 
              }
            },
            margin: { l: 0, r: 0, t: 10, b: 10 },
          }}
          style={{ width: "100%", height: "600px" }}
          useResizeHandler={true}
        />      
      </div>
    );
  }
  return null;
}

export default PCAPlot;